export default "__VITE_ASSET__EB44lWfm__"